export default "__VITE_ASSET__BOuCQYg3__"